'use client'

import { useState } from 'react'
import { Button } from '../shared/button'

export const SubscribeForm = () => {
  const [email, setEmail] = useState('')
  const [honeypot, setHoneypot] = useState('')
  const [status, setStatus] = useState<
    'idle' | 'loading' | 'success' | 'error'
  >('idle')
  const [message, setMessage] = useState<string>('')

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!email) return
    setStatus('loading')
    setMessage('')
    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, honeypot }),
      })
      const data = await res.json()
      if (!res.ok) {
        setStatus('error')
        setMessage(data?.error ?? 'Subscription failed')
        return
      }
      setStatus('success')
      setMessage('Thanks! You are on the list.')
      setEmail('')
    } catch (err) {
      console.error('Subscription error:', err)
      setStatus('error')
      setMessage('Network error. Please try again later.')
    }
  }

  return (
    <form onSubmit={onSubmit} className="flex">
      {/* Honeypot field - hidden from users but visible to bots */}
      <input
        type="text"
        name="website"
        value={honeypot}
        onChange={(e) => setHoneypot(e.target.value)}
        autoComplete="off"
        tabIndex={-1}
        aria-hidden="true"
        className="absolute left-[-9999px] w-0 h-0 opacity-0"
      />
      <input
        type="email"
        inputMode="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        aria-label="Email address"
        className="bg-gradient-to-r from-white/5 to-transparent rounded-l-xl px-4 py-2 lg:min-w-[250px] border border-primary border-r-0 focus:outline-none focus:border-primary"
      />
      <Button type="submit" className="-ml-2" disabled={status === 'loading'}>
        {status === 'loading' ? 'Submitting…' : 'Subscribe'}
      </Button>
      {message && (
        <span className="sr-only" aria-live="polite">
          {message}
        </span>
      )}
    </form>
  )
}
